import script from "./IhramPage.vue?vue&type=script&setup=true&lang=js"
export * from "./IhramPage.vue?vue&type=script&setup=true&lang=js"

import "./IhramPage.vue?vue&type=style&index=0&id=73f01fe6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73f01fe6"]])

export default __exports__